module.exports = __webpack_public_path__ + "static/media/joinAlert.ecc57e06.svg";